"use client"

import Link from "next/link"
import { Button } from "@/components/ui/button"
import { Home, Search, ArrowLeft, FileQuestion, Map } from "lucide-react"

export default function NotFound() {
    return (
        <main className="min-h-screen pt-28 pb-12 flex flex-col items-center justify-center">
            <div className="container px-4 max-w-3xl mx-auto">
                <div className="text-center mb-8">
                    <div className="relative w-40 h-40 mx-auto mb-6 flex items-center justify-center">
                        <div className="relative">
                            <Search className="h-24 w-24 text-primary-gold/30 absolute -left-3 -top-3 transform -rotate-12" />
                            <FileQuestion className="h-16 w-16 text-primary-gold" />
                            <Map className="h-12 w-12 text-gray-300 absolute -right-6 -bottom-6 transform rotate-12" />
                        </div>
                    </div>

                    <h1 className="text-8xl font-bold text-primary-gold/20 mb-4 font-playfair">404</h1>
                    <h2 className="text-3xl font-bold mb-4 font-playfair">Página no encontrada</h2>
                    <p className="text-gray-600 mb-8 max-w-lg mx-auto">
                        Lo sentimos, la página que estás buscando no existe o ha sido movida a otra ubicación.
                    </p>

                    <div className="flex flex-col sm:flex-row gap-4 justify-center">
                        <Button asChild className="flex items-center gap-2 bg-primary-gold hover:bg-primary-gold/90">
                            <Link href="/">
                                <Home className="h-4 w-4" />
                                Volver al inicio
                            </Link>
                        </Button>

                        <Button
                            asChild
                            variant="outline"
                            className="flex items-center gap-2 border-primary-gold text-primary-gold hover:bg-primary-gold/10"
                        >
                            <Link href="/apartments">
                                <Search className="h-4 w-4" />
                                Explorar apartamentos
                            </Link>
                        </Button>

                        <Button onClick={() => window.history.back()} variant="ghost" className="flex items-center gap-2">
                            <ArrowLeft className="h-4 w-4" />
                            Volver atrás
                        </Button>
                    </div>
                </div>

                <div className="mt-12 text-center text-sm text-gray-500">
                    <p>
                        Si crees que esto es un error, por favor{" "}
                        <Link href="/contact" className="text-primary-gold hover:underline">
                            contáctanos
                        </Link>
                        .
                    </p>
                </div>
            </div>
        </main>
    )
}

